import { normalizePlateNumber, IVehicle } from '@okcargo-apps/shared-domain';
import { IVehicleFormValue } from './vehicles-store.model';

export function mapVehicleToFormValue(vehicle: IVehicle): IVehicleFormValue {
  return {
    plateNumber: vehicle.plateNumber,
    type: vehicle.type,
  };
}

export function mapFormValueToVehicle(value: IVehicleFormValue, id: string): IVehicle {
  return {
    id,
    // Final guard: the command must only carry uppercase ASCII letters and digits.
    plateNumber: normalizePlateNumber(value.plateNumber),
    type: value.type,
  };
}
